import {
  Image,
  Linking,
  StyleProp,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';
import Label from '../Label';

interface LinkWithIconDownloadProps {
  text?: string;
  url?: string;
  style?: StyleProp<ViewStyle>;
  onPress?: () => void;
}

export const LinkWithIconDownload = ({
  text = '',
  url = '',
  style,
  onPress,
}: LinkWithIconDownloadProps) => {
  return (
    <TouchableOpacity
      style={[
        {flexDirection: 'row', alignItems: 'center', marginVertical: 20},
        style,
      ]}
      onPress={async () =>
        typeof onPress === 'function'
          ? await onPress()
          : await Linking.openURL(url)
      }>
      <Label
        type="titleGreen14"
        title={text}
        style={{marginRight: 10}}
        textStyle={{textDecorationLine: 'underline'}}
      />
      <Image
        style={{width: 15, height: 20, marginRight: 40}}
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        source={require('../../../ressources/images/PaperDownload.png')}
      />
    </TouchableOpacity>
  );
};
